<template>
  <svg :class="['icon-arrow', direction]" :stroke="stroke" width="30" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61.111 21.721"><g transform="translate(-644 -467.64)"><path d="M695.026,467.64l-.733.681,9.453,10.18-9.453,10.18.733.681,10.085-10.86Z" fill="#1a1818"/><rect width="55" height="1" transform="translate(644 478)" fill="#1a1818"/></g></svg>
</template>

<script>
export default {
  name: 'IconArrow',
  props: {
    direction: {
      type: String,
      default: 'down',
      validator (value) {
        return ['up', 'down', 'left', 'right'].includes(value)
      }
    },
    color: {
      type: String,
      default: 'dark'
    }
  },
  computed: {
    stroke () {
      if (this.color === 'light') {
        return '#FFFFFF'
      } else {
        return '#1C1C1C'
      }
    }
  }
}
</script>

<style>
.icon-arrow.up {
  transform: rotate(90deg);
}

.icon-arrow.down {
  transform: rotate(270deg);
}

.icon-arrow.left {
  transform: rotate(180deg);
}

.icon-arrow.right {
  transform: rotate(0deg);
}
</style>
